import React,{useEffect, useRef} from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'
import { useState } from 'react'
import POForm from '../components/POForm';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import ConfirmDialog from '../../../../../components/ConfirmDialog';
import { Print } from '@mui/icons-material';
import poServices from '../poServices';
import { Link } from 'react-router-dom';
import POPaymentAnalytics from '../components/POPaymentAnalytics';



const CellActions = (props) =>{
    return(
        <>
            <Link to={`/po/details/${props.data.id}`}>{props.data.poNo}</Link>
            {/*

            <POForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
            */}
        </>
    )
  }


function PODashboardPage() {

  const {getMasterLabel, projectDD, userDD, productDD, vendorDD,getDDDataById} = useAppData()
  const [poList,setPOList] = useState(null);
  const gridRef = useRef();
  
  const getPOList =() =>{
    console.log("Getting PO List");
    poServices.getList().then(res=>{
      setPOList(res.data)
    }).catch(error=>{
      console.log(error);
    })

  }

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "PO ID",width:50},
        {headerName:"PO #", width:150, field:"poNo", 
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getPOList,
                remove:remove
            },
        },  
        {headerName: "Product Name", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(productDD,params.data.productId);
            return _data.label;
          }
        },
        {headerName: "Vendor Name", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(vendorDD,params.data.vendorId);
            return _data.label;
          }
        },
        {field:"price",headerName: "Price Per Unit",width:150},
        {field:"qty",headerName: "Qty"},

        {field:"orderDate",headerName: "Order Date"},
        {field:"deliveryDate",headerName: "Delivery Date"},
        
        {field:"totalPrice",headerName: "Total Price",width:150,
          valueGetter:params=>{
            return params.data.price * params.data.qty
          }
        },

        {field:"gstRate",headerName: "GST @", width:150},
        {headerName: "GST Amount",   width:150,
          valueGetter:params=>{
            return (params.data.price * params.data.qty * params.data.gstRate) / 100;
          }
        },

        {headerName: "Grand Total", width:150,
          valueGetter:params=>{
            return (params.data.price * params.data.qty)+((params.data.price * params.data.qty * params.data.gstRate) / 100);
          }
        },

        {headerName: "Paid Amount", width:150, field:"paidAmount" },

        {headerName: "Generated By", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(userDD,params.data.userId);
            return _data.firstName+ " "+ _data.lastName;
          }
        },

        {headerName: "For Project", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(projectDD,params.data.projectId);
            return _data.label;
          }
        },


        {headerName: "PO Generated On", width:150, field:"created_at" },
        {headerName: "Last updated On", width:150, field:"updated_at" },
        
        
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-6'><h4>PO Dashboard</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><POForm callBack={getPOList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 400}}>
              <AgGridReact
                ref={gridRef}
                rowData={poList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getPOList}
              />
            </div>
          </div>
        </div>
        <div className='col-md-12'>
          <POPaymentAnalytics poList={poList} />
        </div>
    </ErpLayout>
    
  )
}

export default PODashboardPage